module.exports = __webpack_public_path__ + "static/media/masjid_kichula12.6694db24.webp";